import React, { Fragment } from 'react';
import styles from 'custom/style.module.css';
import flightStyles from '../flightsfolder.module.css';
import { FormControl, Grid, Typography, MenuItem, Tooltip, Checkbox, Stack } from '@mui/material';
import { CustomInputLabel, CustomSelect, FlexDiv, SelectInputProps, StyledCard, StyledCardTitle } from 'custom/components';

const ManifestSummary = (props) => {
  const { showReportModal } = props;

  function formatNumber(num) {
    return num % 1 === 0 ? Math.round(num) : num.toFixed(1);
  }

  return (
    <StyledCard className={`${styles.mb4} ${flightStyles.manifestCard} ${props.nil ? styles.cardOverlay : ''} ${!props.showManifest ? flightStyles.summaryCollapse: flightStyles.summaryShow} ${!props.showManifest ? styles.pb0: ''}`} sx={!props.showManifest ? { marginTop: '-40px' } : {} }>
      <FlexDiv className={styles.mb1}>
        <StyledCardTitle gutterBottom sx={{ zIndex: 3 }}> 
          <Stack direction='row' alignItems='center'>
            <Checkbox inputProps={{ 'aria-label': 'manifest', }} checked={props.showManifest} onChange={e => props.changeCheck(e)} name='view_manifest'
              sx={{
                padding: '0px',
                marginRight: '10px',
                '& .MuiSvgIcon-root': { fontSize: 16 }
              }}
            />
            {props.summeryType}
          </Stack>
        </StyledCardTitle>
      </FlexDiv>
     
      <div className={`${flightStyles.container} ${props.showManifest ? flightStyles.manifestOpen : ''}`}>
        {
          props.summeryType === 'Manifest Summary' &&
          <Stack direction='row' alignItems='center' spacing={1} justifyContent={'flex-end'} className={showReportModal ? flightStyles.hideReport : ''} mt={-4} mb={2}>
            <CustomInputLabel id='product-filter' aria-label='Enter product'> Filter by product:</CustomInputLabel>
            <FormControl fullWidth className={styles.width170}>
              <CustomSelect
                {...SelectInputProps}
                id='product'
                labelId='product-filter'
                fullWidth
                autoFocus
                name='product'
                value={props?.product}
                onChange={props?.handleProductChange}
                disabled={props.showReportModal}
              >
                <MenuItem value='ALL'>All</MenuItem>
                {props?.productsList?.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </CustomSelect>
            </FormControl>
          </Stack>
        }
        <Grid container spacing={{
          xs: 2,
          sm: 2,
          md: 3,
          lg: 6,
        }} justifyContent={'space-between'}>
          <Grid item xs={12} md={2.5}>
            <Typography variant='div' component='div' textAlign='center' className={flightStyles.summaryHead}>Loose</Typography>
            <Grid container spacing={5} justifyContent='center' sx={{ height: 'calc(100% - 24px)' }}>
              <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={flightStyles.summaryBlock}>
                <Fragment>
                  <div className={flightStyles.title}>Cargo Details</div>
                  <Stack direction='row' justifyContent={{
                    xs: 'space-between',
                    md: 'space-around',
                  }} className={`${flightStyles.data}`}>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>awb</small>
                      <Tooltip title={props.manifestSummary?.loose?.awbs}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.loose?.awbs}</span>
                      </Tooltip>
                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>pcs</small>
                      <Tooltip title={props.manifestSummary?.loose?.pcs}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.loose?.pcs}</span>
                      </Tooltip>

                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>wgt</small>
                      <Tooltip title={props.manifestSummary?.loose?.wgt}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {formatNumber(Math.round(props.manifestSummary?.loose?.wgt*100)/100)}
                        </span>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Fragment>
              </Grid>
            </Grid>

          </Grid>
          <Grid item xs={12} md={4.75}>
            <Typography variant='div' component='div' textAlign='center' className={flightStyles.summaryHead}>Intact</Typography>
            <Grid container spacing={5} justifyContent='center'>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} className={flightStyles.summaryBlock}>
                <Fragment>
                  <div className={flightStyles.title}>Cargo Details</div>
                  <Stack direction='row' justifyContent={{
                    xs: 'space-between',
                    md: 'space-around',
                  }} className={`${flightStyles.data}`}>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>awb</small>
                      <Tooltip title={props.manifestSummary?.intact?.awbs}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.intact?.awbs}</span>
                      </Tooltip>
                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>pcs</small>
                      <Tooltip title={props.manifestSummary?.intact?.pcs}>
                        <span className={`${flightStyles.dataInnerUld}`}>                            
                          {props.manifestSummary?.intact?.pcs}</span>
                      </Tooltip>

                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>wgt</small>
                      <Tooltip title={props.manifestSummary?.intact?.wgt}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {formatNumber(Math.round(props.manifestSummary?.intact?.wgt*100)/100)}</span>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Fragment>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} className={flightStyles.summaryBlock}>
                <Fragment>
                  <div className={flightStyles.title}>Ulds</div>
                  <Stack direction='row' justifyContent={{
                    xs: 'space-between',
                    md: 'space-around',
                  }} className={`${flightStyles.data}`}>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>ld3</small>
                      <Tooltip title={props.manifestSummary?.intactulds?.LD3}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.intactulds?.LD3 < 0 ? Math.abs(props.manifestSummary?.intactulds?.LD3) : props.manifestSummary?.intactulds?.LD3}
                        </span>
                      </Tooltip>
                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>ld7</small>
                      <Tooltip title={props.manifestSummary?.intactulds?.LD7}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.intactulds?.LD7 < 0 ? Math.abs(props.manifestSummary?.intactulds?.LD7) : props.manifestSummary?.intactulds?.LD7}
                        </span>
                      </Tooltip>

                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>md</small>
                      <Tooltip title={props.manifestSummary?.intactulds?.MD}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.intactulds?.MD < 0 ? Math.abs(props.manifestSummary?.intactulds?.MD) : props.manifestSummary?.intactulds?.MD}
                        </span>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Fragment>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4.75}>
            <Typography variant='div' component='div' textAlign='center' className={flightStyles.summaryHead}>Total</Typography>
            <Grid container spacing={5} justifyContent='center'>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} className={flightStyles.summaryBlock}>
                <Fragment>
                  <div className={flightStyles.title}>Cargo Details</div>
                  <Stack direction='row' justifyContent={{
                    xs: 'space-between',
                    md: 'space-around',
                  }} className={`${flightStyles.data}`}>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>AWB</small>
                      <Tooltip title={props.manifestSummary?.total?.awbs}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.total?.awbs}</span>
                      </Tooltip>
                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>PCS</small>
                      <Tooltip title={props.manifestSummary?.total?.pcs}>
                        <span className={`${flightStyles.dataInnerUld}`}>                            
                          {props.manifestSummary?.total?.pcs}</span>
                      </Tooltip>

                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>WGT</small>
                      <Tooltip title={props.manifestSummary?.total?.wgt}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {formatNumber(Math.round(props.manifestSummary?.total?.wgt*100)/100)}</span>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Fragment>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} className={flightStyles.summaryBlock}>
                <Fragment>
                  <div className={flightStyles.title}>Ulds</div>
                  <Stack direction='row' justifyContent={{
                    xs: 'space-between',
                    md: 'space-around',
                  }} className={`${flightStyles.data}`}>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>ld3</small>
                      <Tooltip title={props.manifestSummary?.totalulds?.LD3}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.totalulds?.LD3 < 0 ? Math.abs(props.manifestSummary?.totalulds?.LD3) : props.manifestSummary?.totalulds?.LD3}
                        </span>
                      </Tooltip>
                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>ld7</small>
                      <Tooltip title={props.manifestSummary?.totalulds?.LD7}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.totalulds?.LD7 < 0 ? Math.abs(props.manifestSummary?.totalulds?.LD7) : props.manifestSummary?.totalulds?.LD7}
                        </span>
                      </Tooltip>

                    </Stack>
                    <Stack direction='column'>
                      <small className={styles.textUppercase}>md</small>
                      <Tooltip title={props.manifestSummary?.totalulds?.MD}>
                        <span className={`${flightStyles.dataInnerUld}`}>
                          {props.manifestSummary?.totalulds?.MD < 0 ? Math.abs(props.manifestSummary?.totalulds?.MD) : props.manifestSummary?.totalulds?.MD}
                        </span>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Fragment>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
      </div>

      {!props.showManifest ?
        <Typography variant='caption' color={'text.secondary'} component={'div'} className={styles.textSecondary} textAlign={'center'} fontStyle={'italic'} mt={-4} pb={1.5}>
          {props.summeryType} is hidden. Check the box to view the details.
        </Typography> : ''}   
    </StyledCard>
  );
};

export default ManifestSummary;